import { MethodTypes } from 'constants/methodTypes';
import { Resources } from 'constants/resources';

import { BooleanInputStyled, BoxStyled } from 'pages/Gateways/components/GatewaysForm.styled';
import { useGatewayProviderAutofill } from 'pages/Gateways/hooks/useGatewayProviderAutofill';
import { useFormContext } from 'react-hook-form';
import { Box } from 'shared/mui/Box';
import { AutocompleteMultiselectInput, TextInput } from 'shared/react-admin/Inputs';
import { GenerateNameInput } from 'shared/react-admin/Inputs/TextInputs';
import { ReferenceArrayInput } from 'shared/react-admin/ReferenceInputs';

import { GatewaysCreateBooleanFields } from './components/GatewaysCreateBooleanFields';
import { GatewaysCreateCurrenciesFields } from './components/GatewaysCreateCurrenciesFields';
import { GatewaysCreateMainFields } from './components/GatewaysCreateMainFields';
import { GatewaysCreateStatusRequestFields } from './components/GatewaysCreateStatusRequestFields';

export const GatewaysCreateForm: React.FC = () => {
  const { watch, setValue, resetField } = useFormContext();
  const { fillProviderByGeneratedName, providerFilter, resetProviderFilter } =
    useGatewayProviderAutofill();

  const autocreateMethodWatched = watch('autocreateMethod');

  return (
    <Box pt="24px">
      <BoxStyled sx={{ rowGap: 0 }}>
        <GenerateNameInput
          aliasSource="externalAlias"
          fullWidth
          isRequired
          label="Название"
          onGenerate={fillProviderByGeneratedName}
          size="small"
          source="name"
          variant="outlined"
        />
        <TextInput
          fullWidth
          isRequired
          label="Внешний алиас"
          size="small"
          source="externalAlias"
          variant="outlined"
        />
        <GatewaysCreateMainFields
          onProviderInputChange={resetProviderFilter}
          providerFilter={providerFilter}
        />
        <BooleanInputStyled
          label="Автосоздание метода"
          onChange={() => resetField('gatewayMethodsFromMethods')}
          size="small"
          source="autocreateMethod"
          sx={{ alignSelf: 'center', gridColumnStart: 1 }}
        />
        <ReferenceArrayInput
          enableGetChoices={() => !autocreateMethodWatched}
          filter={watch('pcidss') ? { methodType: { alias: MethodTypes.PCIDSSBankCard } } : {}}
          perPage={200}
          reference={Resources.Methods}
          source="gatewayMethodsFromMethods"
        >
          <AutocompleteMultiselectInput
            clearOnBlur={false}
            disabled={autocreateMethodWatched}
            filterToQuery={(searchText: string) => ({ name: searchText })}
            fullWidth
            label="Методы"
            name="gatewayMethodsFromMethods"
            optionText="name"
            size="small"
          />
        </ReferenceArrayInput>
        <GatewaysCreateCurrenciesFields />
      </BoxStyled>
      <GatewaysCreateStatusRequestFields />
      <GatewaysCreateBooleanFields
        onPcidssChange={() => setValue('gatewayMethodsFromMethods', [])}
      />
    </Box>
  );
};
